import { createRoutes, authenticated } from 'shared/hocs'

import Auth from './auth'
import Admin from './admin'
import Public from './public'
import Profile from './profile'

import Layout from './shared/layout'
import NotFound from './shared/pages/notFound'
import AccountTokenCheck from './profile/accountTokenCheck'

const { renderIfAuthenticated, renderIfNotAuthenticated } = authenticated

export default createRoutes(
  () => [
    {
      redirect: {
        exact: true,
        from: '/',
        to: '/main',
      },
    },
    {
      path: '/admin',
      component: renderIfAuthenticated(Admin),
    },
    {
      path: '/auth',
      component: renderIfNotAuthenticated(Auth),
    },
    {
      path: '/profile',
      component: renderIfAuthenticated(Profile),
    },
    {
      path: '/balance/:token/:nonce?',
      exact: true,
      component: AccountTokenCheck,
    },
    {
      path: '/main',
      component: Public,
    },
    {
      component: NotFound,
    },
  ],
  { switched: true, layout: Layout }
)
